import { render, staticRenderFns } from "./StockBlock.vue?vue&type=template&id=7dcb43fe"
import script from "./StockBlock.vue?vue&type=script&lang=js"
export * from "./StockBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports